import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppSettings } from '../../modules/shared/app.settings';


@Injectable({
  providedIn: 'root'
})
export class EncryptionService {

  constructor() { }

  encrypt(value: any): any {
    if (value) {
      try {
        const key = AppSettings.SPACE_KEY.trim();
        if (!key) {
          return null;
        }

        const iv = CryptoJS.lib.WordArray.random(16);

        const keyWordArray = CryptoJS.enc.Base64.parse(key);

        const encrypted = CryptoJS.AES.encrypt(value.toString(), keyWordArray, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        });

        const combined = iv.concat(encrypted.ciphertext);
        return CryptoJS.enc.Base64.stringify(combined);
      } catch (error) {
        return null;
      }
    }
    return null;
  }

  decrypt(textToDecrypt: any) {
    if (textToDecrypt) {
      try {
        const key = AppSettings.SPACE_KEY.trim();
        if (!key) {
          return null;
        }

        // Try new format first (AES-256-CBC)
        try {
          return this.decryptNewFormat(textToDecrypt, key);
        } catch (newFormatError) {
          // If new format fails, try legacy format for backward compatibility
          return this.decryptLegacyFormat(textToDecrypt, key);
        }
      } catch (error) {
        return null;
      }
    }
    return null;
  }

  private decryptNewFormat(textToDecrypt: string, key: string): string {
    const keyWordArray = CryptoJS.enc.Base64.parse(key);
    const combined = CryptoJS.enc.Base64.parse(textToDecrypt);

    const iv = CryptoJS.lib.WordArray.create(combined.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(combined.words.slice(4));

    const decrypted = CryptoJS.AES.decrypt(
      CryptoJS.lib.CipherParams.create({
        ciphertext
      }),
      keyWordArray,
      {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );

    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      throw new Error('Decryption failed: Invalid encrypted data or wrong key');
    }

    return decryptedString;
  }

  private decryptLegacyFormat(textToDecrypt: string, key: string): string {
    const decrypted = CryptoJS.AES.decrypt(textToDecrypt, key);
    const decryptedString = decrypted.toString(CryptoJS.enc.Utf8);

    if (!decryptedString) {
      throw new Error('Legacy decryption failed: Invalid encrypted data or wrong key');
    }

    return decryptedString;
  }

  encryptPassword(password: string): string | null {
    return this.encrypt(password);
  }

}